import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import axios from 'axios';

import * as ACTIONS from '../../store/actions/actions';

const useForm = (callback, validate) => {

  //----------------------------- FORM INPUTS -----------------------------
  const [values, setValues] = useState({
    //company info in mail footer tables- (Columbus Partner)
    cName: '',
    cAddress: '',
    cStreet: '',
    cNip: '',
    cMail: '',
    cPhone: '',
  });

  const handleChange = e => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value
    });

    // set image from file input
    if (e.target.files && e.target.files[0]) {
      setValues({
        ...values,
        'image':(URL.createObjectURL(e.target.files[0]))
      });
    }
  };

  // FORM SUBMITTING - check values from validate prop and run function from callback if ok.
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false); //you need this for first render(errors are empty before submit and without this callback is ready to run and footer view is visible).
  const handleSubmit = e => {
    e.preventDefault();
    setErrors(validate);
    setIsSubmitting(true);
  };
  useEffect(
    () => {
      if (Object.keys(errors).length === 0 && isSubmitting) {
        callback();
      }
    },
  );

  //----------------------------- FORM IMAGES -----------------------------

  const dispatch = useDispatch();

  //FTP FOLDER - GET IMAGES
  useEffect(() => {
      // fetch('http://localhost:3000/php/images.php')
      fetch('https://stopka.columbusenergy.pl/images.php')
      // fetch('https://columbusenergy.pl/lp/stopka/generator/images.php')
        .then((response) => response.json())
        .then((response) => dispatch(ACTIONS.data_fetch(response)));
  }, []);

  //SELECT IMAGE FROM FOLDER
  const [src, selectFile] = useState(null);

  const handleFileChange = e => {
    selectFile(e)
    // selectFile(URL.createObjectURL(e.target.files[0])) // for input type file
  }

  //CROP IMAGE AREA
  const [crop, setCrop] = useState({
    aspect: 1 / 1,
    x:0,
    y:0,
    width: 200,
    height: 200,
    unit: 'px'
  });

  const [cropImage, setCropImage] = useState(null);
  const [preview, setPreview] = useState(null);
  const [file, setFile] = useState(null);

  //CROP IMAGE FUNC
  function getCroppedImg() {
      const canvas = document.createElement("canvas");
      const scaleX = cropImage.naturalWidth / cropImage.width;
      const scaleY = cropImage.naturalHeight / cropImage.height;
      canvas.width = crop.width;
      canvas.height = crop.height;
      const ctx = canvas.getContext("2d");

      //New lines to be added from https://www.npmjs.com/package/react-image-crop
      const pixelRatio = window.devicePixelRatio;
      canvas.width = crop.width * pixelRatio;
      canvas.height = crop.height * pixelRatio;
      ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
      ctx.imageSmoothingQuality = "high";

      ctx.drawImage(
        cropImage,
        crop.x * scaleX,
        crop.y * scaleY,
        crop.width * scaleX,
        crop.height * scaleY,
        0,
        0,
        crop.width,
        crop.height
      );


      //Code below gives you temporary image, as Base64 string: data:image/jpeg;base64,/9j/4A...
      //We need it to set croppes image preview (blob is a file object, not a link what you are able to show)
      const base64Image = canvas.toDataURL("image/jpeg");
      setPreview(base64Image);


      //A Blob() is almost a File() - it's just missing the two properties below which we will add .lastModifiedDate & .name
      //This final cropped file is sending to server
      canvas.toBlob(blob => {
        blob.lastModifiedDate = new Date();
        blob.name = "cropped-image.png";
        setFile(blob)
      },
      "image/png",
      1,
      )
  }

  //UPLOADER
  function uploadImage() {
    dispatch(ACTIONS.spinner(true))

    const formData =  new FormData();
    formData.append('image', file);
    formData.append('fname', file.name);
    // let url = "https://columbusenergy.pl/lp/stopka/generator/sendCropped.php";
    let url = "https://stopka.columbusenergy.pl/sendCropped.php";
    axios.post(url, formData, {
    })
    .then(res => {
      dispatch(ACTIONS.user_image(res.data.url));
      dispatch(ACTIONS.spinner(false));
    })
    .catch(err => {
      // console.log(err.toJSON());
      // alert('spróbuj ponownie');
      dispatch(ACTIONS.spinner(false));
      dispatch(ACTIONS.image_upload_error(true));
    });
  }
  //UPLOADER THE END

  return {
    handleSubmit,
    handleChange,
    values,
    errors,
    src,
    handleFileChange,
    setCropImage,
    crop,
    setCrop,
    getCroppedImg,
    preview,
    uploadImage,
  };
};

export default useForm;